import { ActionTypeKeys, ActionTypes } from 'embed/actions'
import { DeepReadonly } from 'utility-types'

export type AuthState = DeepReadonly<{
  isLoggedIn: boolean
}>

export const initialAuthState: AuthState = {
  isLoggedIn: false,
}

const reducer = (state: AuthState = initialAuthState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.CREATE_ACCOUNT_SUCCESS:
      return { ...state, isLoggedIn: true }
    default:
      return state
  }
}

export default reducer
